<template>
   <div class="competitor" @click.prevent="goToKorisnik()">
       <Loading :loadingState="loadingState">
           <i class="competitor-pic icon-trophey" :class="{'icon-trophey': !avatar}" :style="{'background-image': avatar && backgroundImage}"></i>
            <h5>
                {{ name }}
            </h5>
            <template v-slot:error>
                {{ message }}
            </template>
       </Loading>
      <i class="competitor-delete" v-if="(vlasnikLige == ligaIdOrGroupId || ligaIdOrGroupId == groupOwner) && loadingState == 'success' && uid != ownUid" @click.prevent="removeUser"></i>
    </div>
</template>

<script>
import Loading from '../components/common/Loading'
import LoadingState from '../utils/loading/LoadingState'
export default {
    name: 'natjecatelj',
    data () {
        return {
            name: false,
            avatar: false,
            loadingState: LoadingState.LOADING,
            vlasnik: false,
            message: 'Nepoznati korisnik'
        }
    },
    props: {
        uid: String
    },
    methods: {
        async getUserData () {
            this.loadingState = LoadingState.LOADING
            try {
                let data = await this.$db.metadata.getUserData(this.uid)
                if (!data) {
                    data = {}
                }
                this.name = data.name
                this.avatar = data.avatar ? data.avatar : false
                this.loadingState = LoadingState.SUCCESS
            } catch (error) {
                console.error(error)
                this.loadingState = LoadingState.ERROR
            }
        },
        async removeUser () {
            this.loadingState = LoadingState.LOADING
            try {
                if (this.$route.name === 'grupacija') {
                    let data = await this.$db.grupe.removeUserFromGroup(
                        {
                            groupId: this.ligaIdOrGroupId,
                            userUid: this.uid
                        })
                    if (data.success) {
                        this.$emit('userdeleted', this.uid)
                        this.loadingState = LoadingState.SUCCESS
                    } else {
                        this.message = data.message
                        this.loadingState = LoadingState.ERROR
                        return
                    }
                } else {
                    let data = await this.$db.lige.removeUserFromLiga(
                        {
                            ligaId: this.ligaIdOrGroupId,
                            userUid: this.uid
                        })
                    if (data.success) {
                        this.$emit('userdeleted', this.uid)
                        this.loadingState = LoadingState.SUCCESS
                    } else {
                        this.message = data.message
                        this.loadingState = LoadingState.ERROR
                        return
                    }
                }
            } catch (error) {
                console.error(error)
                this.message = 'Došlo je do nepoznate pogreške'
                this.loadingState = LoadingState.ERROR
            }
        },
        goToKorisnik () {
            this.$router.push(`/korisnik/${this.uid}`)
        }
    },
    mounted () {
        if (this.uid) {
            this.getUserData()
        }
    },
    computed: {
        ownUid () {
            return this.$store.state.user.uid
        },
        vlasnikLige () {
            return this.$store.state.metadata.userData.vlasnikLige
        },
        groupOwner () {
            return this.$store.state.metadata.userData.groupOwner
        },
        ligaIdOrGroupId () {
            return this.$route.params.id
        },
        backgroundImage () {
            try {
                return `url(${this.avatar})`
            } catch (error) {
                console.log(error)
            }
            return ''
        }
    },
    components: {
        Loading
    }
}
</script>

<style lang="scss" scoped>
.competitor {
    /deep/ .loading-continer {
        padding: 0;
        .loading {
            padding: 0;
            p {
                margin: 0;
            }
        }
    }
}
</style>
